import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";

const OrderCompleteComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [dateType, setDateType] = useState("today");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "complete_date",
    searchStatus: "total",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("payment_created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [orderDetail, setOrderDetail] = useState({});
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [error, setError] = useState("");

  const searchDateItems = [
    { searchText: "구매확정일", searchType: "complete_date" },
    { searchText: "결제일", searchType: "payment_created_at" },
    { searchText: "발송일", searchType: "ship_date" },
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    // {label: '입금대기', value: 'ready'},
    // {label: '입금완료', value: 'paid'},
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    // {label: '배송준비중', value: 'delivery_ready'},
    // {label: '배송중', value: 'delivery_shipping'},
    // {label: '배송완료', value: 'delivery_complete'},
    { label: "구매확정", value: "complete" },
    // {label: '취소요청', value: 'cancel_request'},
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    // {label: '취소완료', value: 'cancel_complete'},
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    // complete_date: '구매확정일순'
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 90,
      dataIndex: "order_id",
      key: "order_id",
      fixed: "left",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "구매확정일",
      // width: 160,
      dataIndex: "complete_date",
      key: "complete_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD");
          return date;
        }
      },
    },
    {
      title: "구매자명",
      // width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "수취인명",
      // width: 80,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "연락처",
      // width: 80,
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
      render: (value) => {
        return value.replaceAll("-", "");
      },
    },
    {
      title: "상품번호",
      // width: 80,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 200,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      // width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "수량",
      // width: 60,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
    },
    {
      title: "상품별 총 주문금액",
      // width: 150,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "주문상태",
      // width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value) => {
        return status.orderStatusChange(value);
      },
    },
    {
      title: "발송처리일",
      width: 100,
      dataIndex: "ship_date",
      key: "ship_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === null || value === "") {
          return value;
        } else {
          const date = moment(value).format("YYYY.MM.DD");
          return date;
        }
      },
    },
    {
      title: "배송완료일",
      // width: 100,
      dataIndex: "ship_complete_date",
      key: "ship_complete_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === null || value === "") {
          return value;
        } else {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "결제일",
      // width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
  ];

  useEffect(() => {}, []);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    getUserOrderList();
  }, [orderType, orderBy]);

  const getUserOrderList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "orderComplete",
          searchDateItems[0].searchType,
          moment().startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[0].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "orderComplete",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "orderComplete",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getUserOrderList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[0].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[0].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    getUserOrderList("initial");
  };

  const handleRowEvent = (record) => {
    return {
      onClick: () => {
        if (selectedRowKey.includes(record.order_detail_id)) {
          setSelectedRowKey(
            selectedRowKey.filter((key) => key !== record.order_detail_id),
          );
          setSelectedRow(
            selectedRow.filter(
              (row) => row.order_detail_id !== record.order_detail_id,
            ),
          );
        } else {
          setSelectedRowKey([...selectedRowKey, record.order_detail_id]);
          setSelectedRow([...selectedRow, record]);
        }
      },
    };
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("payment_created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };

  return (
    <>
      <ContentHeaderComponent title="구매확정 내역" />
      <div className="product-register-wrap">
        {/*구매확정내역검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div>
            <span className="product-register-box-title">
              주문목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
        </Row>
        {/*<Row className="product-register-border-box" justify={"space-between"} wrap={false}>*/}
        {/*    <div>*/}
        {/*        <Button className="order-status-change-button" disabled={true}>구매확정 후 취소처리</Button>*/}
        {/*    </div>*/}
        {/*</Row>*/}
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            scroll={{ x: "max-content" }}
            tableLayout={"auto"}
            onChange={tableOnChange}
            onRow={handleRowEvent}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        {/*<div className="product-register-border-box" style={{ backgroundColor: "#f8f9fd", height: "fit-content", padding: "15px 25px" }}>*/}
        {/*    <Form.Item*/}
        {/*        className="order-bottom-form-item center-label"*/}
        {/*        label="취소"*/}
        {/*        labelAlign="left"*/}
        {/*        colon={false}*/}
        {/*        labelCol={{ span: 3 }}*/}
        {/*        wrapperCol={{ span: 21 }}*/}
        {/*    >*/}
        {/*        <Button className="order-status-change-button" disabled>구매확정 후 취소처리</Button>*/}
        {/*    </Form.Item>*/}
        {/*</div>*/}
      </div>

      {/*주문 상세 페이지*/}
      {isOrderModalOpen && (
        <Modal
          title="상품주문정보 조회"
          wrapClassName="order-detail-modal-wrap"
          visible={isOrderModalOpen}
          centered={true}
          onCancel={handleOrderDetailModalCancel}
          footer={null}
          width="70%"
        >
          <OrderDetailComponent
            orderDetail={orderDetail}
            handleOrderDetailModalCancel={handleOrderDetailModalCancel}
            getUserOrderList={getUserOrderList}
          />
        </Modal>
      )}
    </>
  );
};

export default OrderCompleteComponent;
